module.exports = __webpack_public_path__ + "aebcfbd1de42cb360c2a714643f4b4fe.MP3";